import { useLocation, useRouter } from "@tanstack/react-router";
import { parseScopedThreadKey } from "@cmmd-forge/client-runtime";
import { assistantCitationFromLocation } from "../../lib/assistantCitationNavigation";
import { TimelineViewport, type TimelineViewportProps } from "./TimelineViewport";

function RoutedTimelineViewport(props: TimelineViewportProps) {
  const location = useLocation();
  const source = assistantCitationFromLocation(location.href);
  const threadRef = parseScopedThreadKey(props.routeThreadKey);
  const citationRequest =
    source &&
    source.environmentId === threadRef?.environmentId &&
    source.threadId === threadRef.threadId
      ? {
          citation: source,
          key:
            location.state.assistantCitationActivation ?? location.state.__TSR_key ?? location.href,
        }
      : null;
  return <TimelineViewport {...props} citationRequest={citationRequest} />;
}

export function ThreadTimelineViewport(props: TimelineViewportProps) {
  const router = useRouter({ warn: false });
  return router ? <RoutedTimelineViewport {...props} /> : <TimelineViewport {...props} />;
}
